import { useEffect, useRef } from 'react';
import { useAudioStore } from '@/store/audioStore';
import { audioEngine } from '@/lib/audio/AudioEngine';

/**
 * Sets up the audio engine on app mount:
 * 1. Syncs volume settings from Zustand → engine gain nodes
 * 2. Resumes AudioContext + preloads samples on first user gesture
 */
export function useAudioInitialization() {
    const { masterVolume, fxVolume, voiceVolume, uiVolume } = useAudioStore();
    const preloadedRef = useRef(false);

    // Sync volumes
    useEffect(() => {
        audioEngine.setVolume('master', masterVolume);
        audioEngine.setVolume('fx', fxVolume);
        audioEngine.setVolume('voice', voiceVolume);
        audioEngine.setVolume('ui', uiVolume);
    }, [masterVolume, fxVolume, voiceVolume, uiVolume]);

    // Resume + preload on first user gesture
    useEffect(() => {
        const handleInteraction = () => {
            audioEngine.resume();

            if (!preloadedRef.current) {
                preloadedRef.current = true;
                audioEngine.preload().catch(console.error);
            }
        };

        window.addEventListener('click', handleInteraction);
        window.addEventListener('keydown', handleInteraction);
        window.addEventListener('touchstart', handleInteraction);

        return () => {
            window.removeEventListener('click', handleInteraction);
            window.removeEventListener('keydown', handleInteraction);
            window.removeEventListener('touchstart', handleInteraction);
        };
    }, []);
}
